// TODO call this on resulting ZSL to make sure none of it is indexed
export const removeIndexingFromZsl = (zsl: any) => {
  // This is a workaround until the backend stops returning indexed: true
  // (it is technically in the ZSL spec according but not supported by tables)

  const modifiedTables = zsl.tables?.map((table: any) => {
    return {
      ...table,
      fields: table.fields?.map((field: any) => {
        delete field.options.indexed;

        return field;
      }),
    };
  });

  return {
    ...zsl,
    tables: modifiedTables,
  };
};
